import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VisitTracker = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Skip tracking for admin users
    if (user?.is_admin) {
      return;
    }

    // Skip tracking for admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Check if this page was already tracked in this session
    const sessionKey = `visited_${location.pathname}`;
    const alreadyTracked = sessionStorage.getItem(sessionKey);
    
    if (alreadyTracked) {
      return; // Already tracked this page in this session
    }

    // Track page visit
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`, {
          page_url: location.pathname,
          referer: document.referrer || ''
        });
        
        // Mark this page as tracked for this session
        sessionStorage.setItem(sessionKey, 'true');
      } catch (error) {
        // Silently fail - don't interrupt user experience
        console.debug('Visit tracking failed:', error.message);
      }
    };

    // Small delay to avoid tracking during rapid navigation
    const timer = setTimeout(trackVisit, 500);

    return () => clearTimeout(timer);
  }, [location.pathname, user]);

  return null; // This component doesn't render anything
};

export default VisitTracker;
